<template>
  <v-container grid-list-md class="pa-0 vehicle-details-root">
    <v-row class="flex-wrap">
      <!------------------------------------------DIVIDER------------------------------------------>

      <v-col cols="12" lg="12" md="12" xl="12">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="vehicle-details-divider-row mt-2 mb-1 mx-1"
        >
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />

          <div
            class="vehicle-details-divider-label mx-2 mx-sm-4 px-1 text-h6 font-weight-medium text-center"
          >
            {{ $t("vehicle_entry.car_details") }}
          </div>
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />
        </v-row>
      </v-col>
      <!---------------------------------------LICENSE PLATE--------------------------------------->
      <v-col cols="12" sm="5" lg="5" md="5">
        <v-tooltip v-if="!canSearchTarga" location="top">
          <template #activator="{ props }">
            <div
              v-bind="props"
              class="plate-wrapper"
              style="position: relative"
            >
              <v-text-field
                v-model="targa"
                return-masked-value
                mask="AA###AA"
                :disabled="!canSearchTarga"
                :color="foundTarga ? 'success' : 'error'"
                :append-inner-icon="
                  foundPlate
                    ? 'mdi-check-circle-outline'
                    : 'mdi-alert-circle-outline'
                "
                :label="$t('vehicle_entry.targa') + ' ' + examplePlateFormat"
                :loading="loadingTarga"
                variant="outlined"
                hide-details
              />
            </div>
          </template>

          <span
            ><v-icon color="warning">mdi-alert-outline</v-icon>
            {{ $t("plate_search_disabled_message") }}</span
          >
        </v-tooltip>
        <div v-else>
          <v-text-field
            v-model="targa"
            return-masked-value
            mask="AA###AA"
            :disabled="!canSearchTarga"
            :color="foundTarga ? 'success' : 'error'"
            :append-inner-icon="
              foundPlate
                ? 'mdi-check-circle-outline'
                : 'mdi-alert-circle-outline'
            "
            :label="$t('vehicle_entry.targa') + ' ' + examplePlateFormat"
            :loading="loadingTarga"
            variant="outlined"
            hide-details
            @keyup.enter="searchTarga()"
            @click:append-inner="searchTarga()"
          />
        </div>
      </v-col>
      <!--------------------------------------------VIN-------------------------------------------->
      <v-col cols="12" sm="4" lg="4" md="4">
        <v-text-field
          ref="vinField"
          v-model="vin"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.frame')"
          color="red-darken-1"
          variant="outlined"
          :error-messages="error"
          @input="validateVIN"
        />
      </v-col>
           <!--------------------------------------PRACTICE NUMBER-------------------------------------->
      <v-col cols="12" sm="3" lg="3" md="3">
        <v-text-field
          v-model="pra"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.practice_number')"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <v-col cols="12" class="py-0">
      <!---
        <div class="text-caption text-medium-emphasis py-0">
          {{ $t("vehicle_entry.identifier_pair_hint") }}
        </div>
        --->
        <div v-if="identifierError" class="text-caption text-error py-0 my-0">
          {{ identifierError }}
        </div>
      </v-col>
         <!------------------------------------------DIVIDER------------------------------------------>

      <v-col cols="12" lg="12" md="12" xl="12">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="vehicle-details-divider-row mt-2 mb-1 mx-1"
        >
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />

          <div
            class="vehicle-details-divider-label mx-2 mx-sm-4 px-1 text-h6 font-weight-medium text-center"
          >
            {{ $t("vehicle_entry.engine") }}
          </div>
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />
        </v-row>
      </v-col>
        <!--------------------------------------WORKING ENGINE--------------------------------------->
      <v-col cols="12" sm="6">
        <v-select
          v-model="workingEngine"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.working_engine')"
          :items="workingEngineSelection"
          item-title="title"
          item-value="value"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>

        <!---------------------------------------NUMBER OF KM---------------------------------------->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="kmInput"
          :disabled="$props.disabled"
          inputmode="numeric"
          :label="$t('vehicle_entry.info.number_of_km')"
          color="red darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
        <!------------------------------------------DIVIDER------------------------------------------>

      <v-col cols="12" lg="12" md="12" xl="12">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="vehicle-details-divider-row mt-2 mb-1 mx-1"
        >
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />

          <div
            class="vehicle-details-divider-label mx-2 mx-sm-4 px-1 text-h6 font-weight-medium text-center"
          >
            {{ $t("vehicle_entry.gearbox") }}
          </div>
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />
        </v-row>
      </v-col>
   
     
    
      <!-------------------------------------TRANSMISSION TYPE------------------------------------->
      <v-col cols="12" sm="6">
        <v-select
          v-model="transmissionType"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.transmission_type')"
          :items="transmissionTypeItems"
          item-title="title"
          item-value="value"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <!--------------------------------------NUMBER OF GEARS-------------------------------------->
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="numberOfGears"
          :disabled="$props.disabled"
          type="number"
          :min="0"
          step="1"
          :label="$t('vehicle_entry.info.number_of_gears')"
          color="red-darken-1"
          variant="outlined"
          hide-details
          @blur="floorNumberField('numberOfGears')"
        />
      </v-col>
      <!------------------------------------TRANSMISSION LAYOUT------------------------------------>
      <v-col cols="12" sm="3">
        <v-select
          v-model="transmissionLayout"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.transmission_layout')"
          :items="transmissionLayoutItems"
          item-title="title"
          item-value="value"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
        
             <!------------------------------------------DIVIDER------------------------------------------>

      <v-col cols="12" lg="12" md="12" xl="12">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="vehicle-details-divider-row mt-2 mb-1 mx-1"
        >
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />

          <div
            class="vehicle-details-divider-label mx-2 mx-sm-4 px-1 text-h6 font-weight-medium text-center"
          >
            {{ $t("vehicle_entry.exterior_interior") }}
          </div>
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />
        </v-row>
      </v-col>
     
        <!--------------------------------------INTERNAL STATE--------------------------------------->
      <v-col cols="12" sm="6">
        <v-select
          v-model="internalState"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.internal_state')"
          :items="internalStateItems"
          item-title="title"
          item-value="value"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
        <!--------------------------------------INTERIOR TYPE---------------------------------------->
      <v-col cols="12" sm="6">
        <v-select
          v-model="interiorType"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.interior_type')"
          :items="interiorTypeItems"
          item-title="title"
          item-value="value"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <!--------------------------------------INTERNAL COLOR--------------------------------------->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="internalColor"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.internal_color')"
          :hint="$t('vehicle_entry.info.color_name_hint')"
          persistent-hint
          name="vehicle-internal-color"
          autocomplete="off"
          color="red-darken-1"
          variant="outlined"
          hide-details="auto"
        >
          <template #prepend-inner>
            <v-menu
              v-model="internalColorCodeOpen"
              :close-on-content-click="false"
              :disabled="$props.disabled"
              location="bottom start"
            >
              <template #activator="{ props: menuProps }">
                <v-btn
                  icon
                  variant="flat"
                  class="color-swatch-btn"
                  v-bind="menuProps"
                  :disabled="$props.disabled"
                  :style="{
                    backgroundColor: internalColorCode || '#ffffff',
                  }"
                  :aria-label="$t('vehicle_entry.info.internal_color')"
                />
              </template>
              <v-color-picker
                v-model="internalColorCode"
                mode="hex"
                :modes="['hex']"
                elevation="2"
              />
            </v-menu>
          </template>
          <template #append-inner>
            <span v-if="internalColorCode" class="color-hex-value">
              {{ internalColorCode }}
            </span>
          </template>
        </v-text-field>
      </v-col>
     <!--------------------------------------EXTERNAL COLOR--------------------------------------->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="externalColor"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.external_color')"
          :hint="$t('vehicle_entry.info.color_name_hint')"
          persistent-hint
          name="vehicle-external-color"
          autocomplete="off"
          color="red-darken-1"
          variant="outlined"
          hide-details="auto"
        >
          <template #prepend-inner>
            <v-menu
              v-model="externalColorCodeOpen"
              :close-on-content-click="false"
              :disabled="$props.disabled"
              location="bottom start"
            >
              <template #activator="{ props: menuProps }">
                <v-btn
                  icon
                  variant="flat"
                  class="color-swatch-btn"
                  v-bind="menuProps"
                  :disabled="$props.disabled"
                  :style="{
                    backgroundColor: externalColorCode || '#ffffff',
                  }"
                  :aria-label="$t('vehicle_entry.info.external_color')"
                />
              </template>
              <v-color-picker
                v-model="externalColorCode"
                mode="hex"
                :modes="['hex']"
                elevation="2"
              />
            </v-menu>
          </template>
          <template #append-inner>
            <span v-if="externalColorCode" class="color-hex-value">
              {{ externalColorCode }}
            </span>
          </template>
        </v-text-field>
      </v-col>
      <!------------------------------------------DIVIDER------------------------------------------>
      <v-col cols="12" lg="12" md="12" xl="12">
        <v-row
          no-gutters
          align="center"
          justify="center"
          class="vehicle-details-divider-row mt-2 mb-1 mx-1"
        >
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />

          <div
            class="vehicle-details-divider-label mx-2 mx-sm-4 px-1 text-h6 font-weight-medium text-center"
          >
            {{ $t("vehicle_entry.other_details") }}
          </div>
          <v-divider
            class="flex-grow-1 d-none d-sm-flex"
            style="border-width: 1px; border-color: black; opacity: 100"
          />
        </v-row>
      </v-col>

     <!-------------------------------------VEHICLE CONDITION------------------------------------->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="vehicleCondition"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.vehicle_condition')"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <!-----------------------------------------LOCATION------------------------------------------>
      <v-col cols="12" sm="6">
        <v-select
          v-model="location"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.location')"
          :items="carLocations"
          item-title="name"
          item-value="_id"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <!-------------------------------------REGISTRATION YEAR------------------------------------->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="registrationYear"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.registration_year')"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <!-------------------------------------------NOTES------------------------------------------->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="notes"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.notes')"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
      <!--------------------------------------WITHDRAWN PIVA--------------------------------------->
      <v-col cols="12" sm="6">
        <v-select
          v-model="withdrawnPIVA"
          :disabled="$props.disabled"
          :label="$t('vehicle_entry.info.withdrawn_piva')"
          :items="withdrawnPIVASelection"
          item-title="title"
          item-value="value"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
    
      <!--TEMPORARY-->
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="location"
          :disabled="true"
          label="Vecchia posizione"
          color="red-darken-1"
          variant="outlined"
          hide-details
        />
      </v-col>
    </v-row>
    <v-dialog v-model="carExists" width="300px">
      <v-card-title class="redColor d-flex text-white">
        <span class="headline"> </span>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          color="white"
          size="x-small"
          @click="closeError()"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card>
        <!--ALERT-->
        <v-alert
          :model-value="alert.value"
          :type="alert.type"
          variant="tonal"
          class="mt-2 ma-3"
        >
          {{ $t(alert.message) }}
        </v-alert>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  props: ["disabled"],
  data: () => ({
    targa: "",
    examplePlateFormat: ": (DG853SV)",
    vin: "",
    transmissionType: "",
    transmissionLayout: "",
    numberOfGears: "",
    externalColor: "",
    externalColorCode: null,
    externalColorCodeOpen: false,
    internalColor: "",
    internalColorCode: null,
    internalColorCodeOpen: false,
    interiorType: "",
    internalState: "",
    vehicleCondition: "",
    // frame: '',
    pra: "",
    km: "",
    location: null,
    notes: "",
    workingEngine: true,
    workingEngineSelection: [
      { title: "Yes", value: true },
      { title: "No", value: false },
    ],
    registrationYear: "",
    withdrawnPIVA: false,
    withdrawnPIVASelection: [
      { title: "Yes", value: true },
      { title: "No", value: false },
    ],
    loadingTarga: false,
    foundTarga: null,
    canSearchTarga: false,
    carLocations: [],
    loadingCarLocations: false,
    error: "",
    identifierError: "",
    carExists: false,
    alert: { value: false, type: "error", message: "" },
  }),
  computed: {
    transmissionTypeItems() {
      return [
        { title: this.$t("vehicle_entry.info.options.automatic"), value: "automatic" },
        { title: this.$t("vehicle_entry.info.options.manual"), value: "manual" },
        { title: this.$t("vehicle_entry.info.options.semi_automatic"), value: "semi_automatic" },
      ];
    },
    transmissionLayoutItems() {
      return [
        { title: this.$t("vehicle_entry.info.options.front"), value: "front" },
        { title: this.$t("vehicle_entry.info.options.rear"), value: "rear" },
        { title: this.$t("vehicle_entry.info.options.four_by_four"), value: "4x4" },
      ];
    },
    internalStateItems() {
      return [
        { title: this.$t("vehicle_entry.info.options.excellent"), value: "excellent" },
        { title: this.$t("vehicle_entry.info.options.fair"), value: "fair" },
        { title: this.$t("vehicle_entry.info.options.poor"), value: "poor" },
      ];
    },
    interiorTypeItems() {
      return [
        { title: this.$t("vehicle_entry.info.options.Fabric"), value: "Fabric" },
        { title: this.$t("vehicle_entry.info.options.Leather"), value: "Leather" },
        { title: this.$t("vehicle_entry.info.options.Alcantara"), value: "Alcantara" },
        { title: this.$t("vehicle_entry.info.options.Mixed"), value: "Mixed" },
      ];
    },
    kmInput: {
      get() {
        return this.formatThousands(this.km);
      },
      set(value) {
        this.km = this.parseThousands(value);
      },
    },
    vehicleFields() {
      return {
        targa: this.targa,
        vin: this.vin,
        transmissionType: this.transmissionType,
        transmissionLayout: this.transmissionLayout,
        numberOfGears: this.numberOfGears,
        externalColor: this.externalColor,
        externalColorCode: this.externalColorCode,
        internalColor: this.internalColor,
        internalColorCode: this.internalColorCode,
        interiorType: this.interiorType,
        internalState: this.internalState,
        vehicleCondition: this.vehicleCondition,
        pra: this.pra,
        km: this.km,
        location: this.location,
        notes: this.notes,
        workingEngine: this.workingEngine,
        registrationYear: this.registrationYear,
        withdrawnPIVA: this.withdrawnPIVA,
      };
    },
  },
  watch: {
    vin(newVin) {
      if (newVin !== null && newVin !== "") {
        this.validateVIN();
      } else {
        this.error = ""; // Clear error if VIN is empty
      }
    },
    vehicleFields: {
      handler() {
        if (this.identifierError) {
          this.hasRequiredIdentifiers();
        }
        this.$emit("update", this.getDetails());
      },
      deep: true,
    },
  },
  created() {
    this.getLocale();
    this.getInstitution();
    this.getCarLocations();
  },
  methods: {
    isIdentifierFilled(value) {
      return Boolean(value && String(value).trim().length > 0);
    },
    hasRequiredIdentifiers() {
      const filled = [this.targa, this.vin, this.pra].filter((value) =>
        this.isIdentifierFilled(value),
      );
      this.identifierError =
        filled.length >= 2
          ? ""
          : this.$t("vehicle_entry.identifier_pair_required");
      this.$emit("identifier-error", this.identifierError);
      return filled.length >= 2;
    },
    validateVIN() {
      if (!this.vin || this.vin == null) {
        this.error = "";
        return true; // No validation needed if empty
      }

      const vin = this.vin.toUpperCase();
      const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/; // 17 valid characters

      if (!vinRegex.test(vin)) {
        this.error =
          "Il VIN deve essere di 17 caratteri e non contenere I, O, Q.";
        return false;
      }
      // European VINs do not require checksum validation

      // if (!this.checkVinChecksum(vin)) {
      //   this.error = 'VIN non valido: errore nel checksum.';
      //   return false;
      // }

      this.error = "";
      return true;
    },
    checkVinChecksum(vin) {
      const mapValues = {
        A: 1,
        B: 2,
        C: 3,
        D: 4,
        E: 5,
        F: 6,
        G: 7,
        H: 8,
        J: 1,
        K: 2,
        L: 3,
        M: 4,
        N: 5,
        P: 7,
        R: 9,
        S: 2,
        T: 3,
        U: 4,
        V: 5,
        W: 6,
        X: 7,
        Y: 8,
        Z: 9,
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
      };

      const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;

      for (let i = 0; i < 17; i++) {
        sum += mapValues[vin[i]] * weights[i];
      }

      const remainder = sum % 11;
      const checkDigit = remainder === 10 ? "X" : remainder.toString();

      return vin[8] === checkDigit;
    },
    // checkVinChecksum(vin) {
    //   const mapValues = {
    //     A: 1,
    //     B: 2,
    //     C: 3,
    //     D: 4,
    //     E: 5,
    //     F: 6,
    //     G: 7,
    //     H: 8,
    //     J: 1,
    //     K: 2,
    //     L: 3,
    //     M: 4,
    //     N: 5,
    //     P: 7,
    //     R: 9,
    //     S: 2,
    //     T: 3,
    //     U: 4,
    //     V: 5,
    //     W: 6,
    //     X: 7,
    //     Y: 8,
    //     Z: 9,
    //     0: 0,
    //     1: 1,
    //     2: 2,
    //     3: 3,
    //     4: 4,
    //     5: 5,
    //     6: 6,
    //     7: 7,
    //     8: 8,
    //     9: 9,
    //   };

    //   const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
    //   let sum = 0;

    //   for (let i = 0; i < 17; i++) {
    //     sum += mapValues[vin[i]] * weights[i];
    //   }

    //   const remainder = sum % 11;
    //   const checkDigit = remainder === 10 ? 'X' : remainder.toString();

    //   return vin[8] === checkDigit;
    // },
    getLocale() {
      this.workingEngineSelection[0].title = this.$t("vehicle_entry.info.yes");
      this.workingEngineSelection[1].title = this.$t("vehicle_entry.info.no");
      this.withdrawnPIVASelection[0].title = this.$t("vehicle_entry.info.yes");
      this.withdrawnPIVASelection[1].title = this.$t("vehicle_entry.info.no");
    },
    formatThousands(value) {
      const digits = String(value ?? "").replace(/\D/g, "");
      if (!digits) return "";
      return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    parseThousands(value) {
      const digits = String(value ?? "").replace(/\D/g, "");
      if (!digits) return "";
      const parsed = Number.parseInt(digits, 10);
      return Number.isNaN(parsed) ? "" : parsed;
    },
    allowedSelectValue(current, items) {
      if (current && items.some((item) => item.value === current)) {
        return current;
      }
      return "";
    },
    floorNumberField(field) {
      const value = this[field];
      if (value === "" || value == null) {
        this[field] = "";
        return;
      }
      this[field] = Math.floor(value);
    },
    getInstitution() {
      getRequest("/institution", `id=${this.$store.getters.institutionId}`)
        .then((response) => {
          if (response.institution && response.institution.length > 0) {
            this.canSearchTarga = !!(
              response.institution[0].plates.remaining > 0
            );
          }
        })
        .catch(() => {});
    },
    getCarLocations() {
      this.loadingCarLocations = true;
      getRequest(
        "/car-location",
        `role=${this.$store.getters.role}&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.carLocations = response.carLocations;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingCarLocations = false;
        });
    },
    searchTarga() {
      if (this.targa && this.targa.length > 0) {
        this.loadingTarga = true;
        getRequest(`/info-car/plate/${this.targa}`, "")
          .then(async (response) => {
            if (response && response.targaExists) {
              this.alert.value = true;
              this.alert.message = "vehicle_entry.car_exists";
              this.carExists = true;
              this.foundTarga = false;
              this.loadingTarga = false;
              return;
            }
            try {
              const brand = await getRequest(
                "/info-car/brand",
                `id=${response.brandId}`,
              );
              const model = await getRequest(
                "/info-car/model",
                `id=${response.modelId}`,
              );
              const version = await getRequest(
                "/info-car/version",
                `id=${response.versionId}`,
              );

              this.foundPlate = true;
              this.$emit("car", { brand, model, version });
              this.foundTarga = true;
              this.vin = response.chassis;
              this.getInstitution();
            } catch {
              this.foundTarga = false;
            }
          })
          .catch((error) => {
            if (error) {
              this.alert.value = true;
              this.alert.message = error.response.data;
              this.carExists = true;
              this.foundTarga = false;
              this.loadingTarga = false;
            }
          })
          .finally(() => {
            this.loadingTarga = false;
          });
      }
    },
    closeError() {
      this.carExists = false;
      this.alert.value = false;
      this.alert.message = "";
      this.targa = "";
      // this.$emit("close-add-vehicle");
    },
    getDetails() {
      return {
        targa: this.targa,
        vin: this.vin,
        transmissionType: this.transmissionType,
        transmissionLayout: this.transmissionLayout,
        numberOfGears: this.numberOfGears,
        externalColor: this.externalColor,
        externalColorCode: this.externalColorCode,
        internalColor: this.internalColor,
        internalColorCode: this.internalColorCode,
        interiorType: this.interiorType,
        internalState: this.internalState,
        vehicleCondition: this.vehicleCondition,
        // frame: this.frame,
        pra: this.pra,
        km: this.km,
        location: this.location,
        notes: this.notes,
        workingEngine: this.workingEngine,
        registrationYear: this.registrationYear,
        withdrawnPIVA: this.withdrawnPIVA,
      };
    },
    setDetails(data) {
      this.targa = data.targa;
      this.vin = data.vin;
      this.transmissionType = this.allowedSelectValue(
        data.transmissionType,
        this.transmissionTypeItems,
      );
      this.transmissionLayout = this.allowedSelectValue(
        data.transmissionLayout,
        this.transmissionLayoutItems,
      );
      this.numberOfGears = data.numberOfGears ?? "";
      this.externalColor = data.externalColor;
      this.externalColorCode = data.externalColorCode || null;
      this.externalColorCodeOpen = false;
      this.internalColor = data.internalColor;
      this.internalColorCode = data.internalColorCode || null;
      this.internalColorCodeOpen = false;
      this.interiorType = this.allowedSelectValue(
        data.interiorType,
        this.interiorTypeItems,
      );
      this.internalState = this.allowedSelectValue(
        data.internalState,
        this.internalStateItems,
      );
      this.vehicleCondition = data.vehicleCondition;
      // this.frame = data.frame;
      this.pra = data.pra;
      this.km = data.km;
      this.location = data.location;
      this.notes = data.notes;
      this.workingEngine = data.workingEngine;
      this.registrationYear = data.registrationYear;
      this.withdrawnPIVA = data.withdrawnPIVA;
    },
    clear() {
      this.identifierError = "";
      this.$emit("identifier-error", "");
      this.targa = "";
      this.vin = "";
      this.transmissionType = "";
      this.transmissionLayout = "";
      this.numberOfGears = "";
      this.externalColor = "";
      this.externalColorCode = null;
      this.externalColorCodeOpen = false;
      this.internalColor = "";
      this.internalColorCode = null;
      this.internalColorCodeOpen = false;
      this.interiorType = "";
      this.internalState = "";
      this.vehicleCondition = "";
      // this.frame = '';
      this.pra = "";
      this.km = "";
      this.location = null;
      this.notes = "";
      this.workingEngine = true;
      this.registrationYear = "";
      this.withdrawnPIVA = false;
    },
  },
};
</script>

<style scoped>
.color-swatch-btn {
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 4px;
  border: 1px solid #d0d5dd;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  margin-right: 2px;
}
.color-hex-value {
  font-family: var(--mono, ui-monospace, monospace);
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.vehicle-details-root :deep(.v-field-label) {
  text-overflow: unset;
  overflow: visible;
}

.vehicle-details-root :deep(.v-select__selection-text) {
  overflow: visible;
  text-overflow: unset;
}

@media (max-width: 959.98px) {
  .vehicle-details-root {
    overflow-x: hidden;
  }

  .vehicle-details-root :deep(.v-field) {
    min-width: 0;
  }

  .vehicle-details-divider-row {
    flex-wrap: wrap;
    row-gap: 0.25rem;
  }

  .vehicle-details-divider-label {
    white-space: normal;
    line-height: 1.3;
    width: 100%;
  }
}

@media (min-width: 600px) {
  .vehicle-details-divider-row {
    flex-wrap: nowrap;
  }

  .vehicle-details-divider-label {
    white-space: nowrap;
    width: auto;
  }
}
</style>
